import React from 'react';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

const Select = ({
  setValue = () => {},
  label = 'label',
  options = {},
  placeholder = 'Select an option',
  register,
  errorMessage,
  required = false,
}) => {
  const getOptions = () => {
    let arr = [];
    for (const key in options) {
      arr.push(
        <option key={key} value={key}>
          {options[key]}
        </option>,
      );
    }
    return arr;
  };

  return (
    <div className="mb-8">
      <label className="uppercase tracking-widest text-xl">
        {label}
        {required ? (
          <span className="text-red-500 text-md relative -top-1 left-1">*</span>
        ) : null}
        <select
          className="block h-12 w-full mt-2 px-3 border text-base border-gray-300 bg-black focus:outline-none focus:ring-primary-500 focus:border-primary-500"
          {...register(
            label.toLowerCase().split(' ').join('_').split('/').join('_'),
          )}
          onChange={(e) => {
            setValue(e.target.value);
          }}
        >
          <option value="">{placeholder}</option>
          {getOptions().map((item) => item)}
        </select>
      </label>
      <ErrorMessage message={errorMessage} />
    </div>
  );
};

export default Select;
